import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material';

import { ColumnsSettingsComponent } from './columns-settings.component';
import { UserColumnsSettingsService } from '../../services/user-columns-settings.service';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';


@NgModule({
  declarations: [
    ColumnsSettingsComponent
  ],
  exports: [
    ColumnsSettingsComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    TranslateModule,
    IconButtonModule
  ],
  providers: [
    UserColumnsSettingsService
  ]
})
export class ColumnsSettingsModule { }
